var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(" Please enter all departments in your organisation as tag name in the field. Department information will be utilised in creating de-identified management report. ")]),_c('business-tags')],1)}
var staticRenderFns = []

export { render, staticRenderFns }